import React from 'react'
import { StyleSheet, TouchableOpacity, View } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Icon, Text } from '@components'
import { Theme } from '@theme'

interface StatCardProps {
  label: string
  value: string
  hint?: string
  /** Emphasis colour of the number (defaults to the app text colour). */
  color?: string
  onPress: () => void
  testID: string
}

/** A key figure that leads to the list behind it. */
export const StatCard: React.FC<StatCardProps> = ({ label, value, hint, color, onPress, testID }) => {
  const theme = useTheme()
  const styles = getStyles(theme)
  return (
    <TouchableOpacity
      accessibilityRole="button"
      accessibilityLabel={`${label}: ${value}`}
      testID={testID}
      style={styles.card}
      onPress={onPress}
    >
      <View style={styles.top}>
        <Text type="bodySmall" color={theme.colors.greyBlue} numberOfLines={2} style={styles.label}>
          {label}
        </Text>
        <Icon name="arrowRight" size={14} color={theme.colors.greyBlue} />
      </View>
      <Text type="titleBold" color={color ?? theme.colors.black} testID={`${testID}-value`}>
        {value}
      </Text>
      {hint ? (
        <Text type="bodyExtraSmall" color={theme.colors.greyBlue} numberOfLines={2}>
          {hint}
        </Text>
      ) : null}
    </TouchableOpacity>
  )
}

const getStyles = (theme: Theme) =>
  StyleSheet.create({
    // Two per row on a phone, up to four on a wide screen.
    card: {
      flexGrow: 1,
      flexBasis: 140,
      minWidth: 140,
      gap: theme.spacing.xs,
      padding: theme.spacing.md,
      borderRadius: theme.border.large,
      backgroundColor: theme.colors.white,
      borderWidth: 1,
      borderColor: theme.colors.grey,
    },
    top: { flexDirection: 'row', alignItems: 'flex-start', gap: theme.spacing.xs },
    label: { flex: 1 },
  })
